<!-- <div class="sensor_threshold_popup" *ngIf="data.type !== 'allMertrics'">
    
    <div class="modal-header">
      <h4 class="modal-title">Sensor Threshold Value</h4>
    </div>

    <div class="modal-body">
      <div class="table-responsive" style="max-height:300px; overflow-y: auto;">
        <table class="table" >
          <thead>
            <tr>
              <th>Sensor Group</th>
              <th>Range</th>
              <th>Green</th>
              <th>Yellow</th>
              <th>Red</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{data.metric_type}}</td>             
              <td>
                <div class="flexnalign">
                  <div class="input-group width_70 m_r_10">
                    <input type="text" [(ngModel)]="data.base_value" class="form-control" placeholder="Min"/>
                  </div>
                  <div class="input-group width_70">
                    <input type="text" [(ngModel)]="data.max_value" class="form-control" placeholder="Max" />
                  </div>
                </div>
              </td>
              <td>
                <div class="input-group width_100">
                  <input type="text" [(ngModel)]="data.threshold_1" class="form-control"/>
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </td>
              <td>
                <div class="flexnalign">
                  <div class="input-group width_100">
                    <input type="text" [(ngModel)]="data.threshold_2" class="form-control" />
                    <div class="input-group-append">
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <div class="input-group width_100">
                  <input type="text" [(ngModel)]="data.threshold_3" class="form-control"/>
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
     
      <textarea class="form-control" placeholder=".....comment"></textarea>
    </div>
    <div class="modal-footer">
  
        <button class="btn primary_btn" mat-button (click)="onSave()">Save</button>
        <button class="btn default_btn" mat-button (click)="onClose()">Close</button>
    </div>
</div> -->

<div class="sensor_threshold_popup" *ngIf="data.type === 'allMertrics'">
  <div class="modal-header">
    <h4 class="modal-title">Sensor Threshold Value</h4>
  </div>

  <div class="modal-body">
    <div class="table-responsive" style="max-height: 300px; overflow-y: auto">
      <table class="table">
        <thead>
          <tr>
            <th>Sensor Group</th>
            <th>Range</th>
            <th>Green</th>
            <th>Yellow</th>
            <th>Red</th>
            <th>Error Counter</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of data.dataAll; let i = index">
            <td>{{ data.metric_name }}</td>
            <td>
              <div class="flexnalign">
                <div class="input-group width_70 m_r_10">
                  <input
                    type="number"
                    [(ngModel)]="data.base_value"
                    name="range_start"
                    [min]="0"
                    class="form-control"
                    placeholder="Min"
                    (input)="updateData($event, i)"
                  />
                </div>
                <div class="input-group width_70">
                  <input
                    type="number"
                    [(ngModel)]="data.max_value"
                    name="range_end"
                    class="form-control"
                    placeholder="Max"
                    (input)="updateData($event, i)"
                  />
                </div>
              </div>
            </td>
            <td>
              <div class="input-group width_100">
                <input
                  type="number"
                  [(ngModel)]="data.threshold_1"
                  name="threshold_1"
                  min="1"
                  class="form-control"
                  (input)="updateData($event, i)"
                />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </td>
            <td>
              <div class="flexnalign">
                <div class="input-group width_100">
                  <input
                    type="number"
                    [(ngModel)]="data.threshold_2"
                    name="threshold_2"
                   min="1"
                    class="form-control"
                    (input)="updateData($event, i)"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">%</span>
                  </div>
                </div>
              </div>
            </td>
            <td class="text-center">
              <div class="input-group width_100">
                <input
                  type="number"
                  [(ngModel)]="data.threshold_3"
                  class="form-control"
                  (input)="updateData($event, i)"
                  disabled
                />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </td>
            <td class="text-center">
              <div class="input-group width_100">
                <input
                  type="number"
                  name="counter"
                  min="0"
                  [(ngModel)]="data.max_counter"
                  class="form-control"
                  (input)="updateData($event, i)"
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <textarea class="form-control" placeholder=".....comment"></textarea>
  </div>
  <div class="modal-footer">
    <button mat-button class="btn primary_btn" (click)="saveMetricsData()" [disabled]="!saveButton">
      Save
    </button>
    <button mat-button class="btn default_btn" (click)="onClose()">
      Close
    </button>
  </div>
</div>
